module.exports = __webpack_public_path__ + "static/img/KOessential4.78657f8e.png";